/*
 * Seed Jewelry - virtual appointment booking (Cal.com) + "Virtual Appointment / Visit a Boutique" tabs.
 * 28 Sep 2026. Markup: snippets/seed-virtual-booking.liquid. Styles: assets/seed-virtual-booking.css.
 *
 * Cal.com API v2, public endpoints, no API key:
 *   GET  {api}/slots     header cal-api-version 2024-09-04
 *   POST {api}/bookings  header cal-api-version 2026-02-25
 * The Cal.com username / event slug / API base come from data attributes (Theme settings -> Appointment form).
 * NOTE: no backslash-u escapes anywhere in this file (the theme upload pipeline decodes them).
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- tabs */

  function selectTab(root, name, focus) {
    if (!root) return;
    var tabs = root.querySelectorAll('[data-seed-tab]');
    var panels = root.querySelectorAll('[data-seed-panel]');
    var found = false;
    tabs.forEach(function (t) { if (t.getAttribute('data-seed-tab') === name) found = true; });
    if (!found) return;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-seed-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-seed-panel') !== name; });
  }

  if (!window.__seedApptTabs) {
    window.__seedApptTabs = true;

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-seed-tab]');
      if (tab) {
        selectTab(tab.closest('[data-seed-tabs-root]'), tab.getAttribute('data-seed-tab'), false);
        return;
      }
      // A button that opens the drawer can pick its tab, e.g. the boutique location cards
      var opener = e.target.closest('[aria-controls="appointment-drawer"][data-seed-appt-tab]');
      if (opener) {
        selectTab(document.querySelector('#appointment-drawer [data-seed-tabs-root]'), opener.getAttribute('data-seed-appt-tab'), false);
      }
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-seed-tab]');
      if (!tab || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var list = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-seed-tab]'));
      var i = list.indexOf(tab);
      var rtl = getComputedStyle(tab).direction === 'rtl';
      var step = (e.key === 'ArrowRight') !== rtl ? 1 : -1;
      var next = list[(i + step + list.length) % list.length];
      selectTab(tab.closest('[data-seed-tabs-root]'), next.getAttribute('data-seed-tab'), true);
      e.preventDefault();
    });

    var applyHash = function () {
      var h = (location.hash || '').replace('#', '');
      if (h !== 'virtual' && h !== 'boutique') return;
      document.querySelectorAll('[data-seed-tabs-root]').forEach(function (root) {
        if (!root.closest('#appointment-drawer')) selectTab(root, h, false);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyHash);
    else applyHash();
    window.addEventListener('hashchange', applyHash);
  }

  /* ------------------------------------------------------------- booking */

  if (customElements.get('seed-virtual-booking')) return;

  var INTL_LOCALE = { en: 'en-US', ru: 'ru-RU', uk: 'uk-UA', ar: 'ar-u-ca-gregory-nu-latn' };
  var ZONES = ['Asia/Dubai', 'Asia/Riyadh', 'Europe/Kyiv', 'Europe/London', 'Europe/Paris', 'America/New_York'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var partsFmtCache = {};
  function zonedParts(date, tz) {
    var f = partsFmtCache[tz] || (partsFmtCache[tz] = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }));
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day };
  }
  function dayKey(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function noonUTC(y, m, d) { return new Date(Date.UTC(y, m - 1, d, 12)); }

  class SeedVirtualBooking extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.user = this.dataset.user;
      this.event = this.dataset.event;
      this.api = (this.dataset.api || 'https://api.cal.com/v2').replace(/\/+$/, '');
      this.lang = this.dataset.lang || 'en';
      this.loc = INTL_LOCALE[this.lang] || 'en-US';
      this.weekStart = (this.lang === 'ru' || this.lang === 'uk') ? 1 : 0;
      try { this.s = JSON.parse(this.querySelector('[data-strings]').textContent); } catch (e) { this.s = {}; }

      this.el = {
        step1: this.querySelector('[data-step="1"]'),
        step2: this.querySelector('[data-step="2"]'),
        step3: this.querySelector('[data-step="3"]'),
        tz: this.querySelector('[data-tz]'),
        month: this.querySelector('[data-month]'),
        prev: this.querySelector('[data-prev]'),
        next: this.querySelector('[data-next]'),
        weekdays: this.querySelector('[data-weekdays]'),
        days: this.querySelector('[data-days]'),
        timesTitle: this.querySelector('[data-times-title]'),
        times: this.querySelector('[data-times]'),
        msg: this.querySelector('[data-msg]'),
        cont: this.querySelector('[data-continue]'),
        summary: this.querySelector('[data-summary]'),
        back: this.querySelector('[data-back]'),
        formMsg: this.querySelector('[data-form-msg]'),
        submit: this.querySelector('[data-submit]')
      };

      this.cache = {};
      this.selectedDay = null;
      this.selectedSlot = null;

      this.setupTimezones();
      this.renderWeekdays();

      var today = zonedParts(new Date(), this.tz);
      this.viewY = today.y;
      this.viewM = today.m;

      this.el.prev.addEventListener('click', () => this.shiftMonth(-1));
      this.el.next.addEventListener('click', () => this.shiftMonth(1));
      this.el.tz.addEventListener('change', () => {
        this.tz = this.el.tz.value;
        this.selectedDay = null;
        this.selectedSlot = null;
        this.load(true);
      });
      this.el.cont.addEventListener('click', () => this.goStep2());
      this.el.back.addEventListener('click', () => this.show(1));
      this.el.step2.addEventListener('submit', (e) => { e.preventDefault(); this.book(); });

      this.renderCalendar();

      // Only call Cal.com once the booking is actually on screen (the drawer is on every page)
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) {
            this._io.disconnect();
            this.load(true);
          }
        });
        this._io.observe(this);
      } else {
        this.load(true);
      }
    }

    /* ---------- timezones */
    tzLabel(tz) {
      var now = new Date();
      var name = tz, off = '';
      try {
        var p = new Intl.DateTimeFormat(this.loc, { timeZone: tz, timeZoneName: 'long' }).formatToParts(now);
        p.forEach(function (x) { if (x.type === 'timeZoneName') name = x.value; });
        var q = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' }).formatToParts(now);
        q.forEach(function (x) { if (x.type === 'timeZoneName') off = x.value; });
      } catch (e) {}
      return off && name.indexOf('GMT') !== 0 ? name + ' (' + off + ')' : name;
    }
    setupTimezones() {
      var browser = 'Asia/Dubai';
      try { browser = Intl.DateTimeFormat().resolvedOptions().timeZone || browser; } catch (e) {}
      if (browser === 'Europe/Kiev') browser = 'Europe/Kyiv';
      var list = [browser].concat(ZONES.filter(function (z) { return z !== browser; }));
      var seen = {};
      var sel = this.el.tz;
      sel.innerHTML = '';
      list.forEach((tz) => {
        var label;
        try { label = this.tzLabel(tz); } catch (e) { return; }
        if (seen[label]) return;
        seen[label] = true;
        var o = document.createElement('option');
        o.value = tz;
        o.textContent = label;
        sel.appendChild(o);
      });
      sel.value = browser;
      this.tz = sel.value || 'Asia/Dubai';
    }

    /* ---------- calendar */
    renderWeekdays() {
      var f = new Intl.DateTimeFormat(this.loc, { weekday: 'short', timeZone: 'UTC' });
      var html = '';
      for (var i = 0; i < 7; i++) {
        var dow = (this.weekStart + i) % 7;           // 0 = Sunday
        html += '<span>' + f.format(noonUTC(2023, 1, 1 + dow)) + '</span>';  // 1 Jan 2023 was a Sunday
      }
      this.el.weekdays.innerHTML = html;
    }

    shiftMonth(delta) {
      var m = this.viewM + delta, y = this.viewY;
      if (m < 1) { m = 12; y--; }
      if (m > 12) { m = 1; y++; }
      this.viewY = y;
      this.viewM = m;
      this.selectedDay = null;
      this.selectedSlot = null;
      this.load(true);
    }

    monthKey() { return this.tz + '|' + this.viewY + '-' + pad(this.viewM); }

    load(autoPick) {
      this.renderCalendar();
      var key = this.monthKey();
      if (this.cache[key]) {
        if (autoPick) this.autoPick();
        this.renderCalendar();
        this.renderTimes();
        return;
      }
      this.loading = true;
      this.renderTimes();
      var y = this.viewY, m = this.viewM;
      var last = new Date(Date.UTC(y, m, 0)).getUTCDate();
      // Pad a day either side (the API range is UTC; the month is in the chosen timezone)
      var start = new Date(Date.UTC(y, m - 1, 1) - 86400000).toISOString().slice(0, 10);
      var end = new Date(Date.UTC(y, m - 1, last) + 86400000).toISOString().slice(0, 10);
      var url = this.api + '/slots?' + new URLSearchParams({
        username: this.user, eventTypeSlug: this.event, start: start, end: end, timeZone: this.tz, format: 'range'
      }).toString();

      var token = (this._token = (this._token || 0) + 1);
      fetch(url, { headers: { 'cal-api-version': '2024-09-04' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then((json) => {
          if (token !== this._token) return;
          var byDay = {};
          var now = Date.now();
          var data = (json && json.data) || {};
          Object.keys(data).forEach((k) => {
            (data[k] || []).forEach((s) => {
              var startIso = typeof s === 'string' ? s : s.start;
              var d = new Date(startIso);
              if (isNaN(d) || d.getTime() < now) return;
              var p = zonedParts(d, this.tz);
              if (p.y !== y || p.m !== m) return;
              var dk = dayKey(p.y, p.m, p.d);
              (byDay[dk] = byDay[dk] || []).push(d);
            });
          });
          Object.keys(byDay).forEach(function (dk) { byDay[dk].sort(function (a, b) { return a - b; }); });
          this.cache[key] = byDay;
          this.loadError = false;
        })
        .catch((err) => {
          if (token !== this._token) return;
          console.warn('[seed-virtual-booking] slots', err);
          this.loadError = true;
        })
        .finally(() => {
          if (token !== this._token) return;
          this.loading = false;
          if (autoPick) this.autoPick();
          this.renderCalendar();
          this.renderTimes();
        });
    }

    autoPick() {
      var days = this.cache[this.monthKey()];
      if (!days) return;
      var keys = Object.keys(days).sort();
      if (!this.selectedDay || !days[this.selectedDay]) this.selectedDay = keys[0] || null;
    }

    renderCalendar() {
      var y = this.viewY, m = this.viewM;
      this.el.month.textContent = new Intl.DateTimeFormat(this.loc, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(noonUTC(y, m, 1));

      var today = zonedParts(new Date(), this.tz);
      this.el.prev.disabled = (y < today.y) || (y === today.y && m <= today.m);

      var days = this.cache[this.monthKey()] || {};
      var first = noonUTC(y, m, 1).getUTCDay();
      var lead = (first - this.weekStart + 7) % 7;
      var last = new Date(Date.UTC(y, m, 0)).getUTCDate();
      var fmtNum = new Intl.DateTimeFormat(this.loc, { day: 'numeric', timeZone: 'UTC' });
      var fmtFull = new Intl.DateTimeFormat(this.loc, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });

      var frag = document.createDocumentFragment();
      for (var i = 0; i < lead; i++) {
        var blank = document.createElement('span');
        blank.className = 'seed-vb__day seed-vb__day--blank';
        frag.appendChild(blank);
      }
      for (var d = 1; d <= last; d++) {
        var dk = dayKey(y, m, d);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'seed-vb__day';
        b.textContent = fmtNum.format(noonUTC(y, m, d));
        b.setAttribute('aria-label', fmtFull.format(noonUTC(y, m, d)));
        var has = !!days[dk];
        if (!has) b.disabled = true;
        if (dk === this.selectedDay) { b.classList.add('is-selected'); b.setAttribute('aria-pressed', 'true'); }
        if (y === today.y && m === today.m && d === today.d) b.classList.add('is-today');
        b.dataset.day = dk;
        b.addEventListener('click', (e) => {
          this.selectedDay = e.currentTarget.dataset.day;
          this.selectedSlot = null;
          this.renderCalendar();
          this.renderTimes();
        });
        frag.appendChild(b);
      }
      this.el.days.innerHTML = '';
      this.el.days.appendChild(frag);
    }

    fmtTime(d) {
      return new Intl.DateTimeFormat(this.loc, { hour: '2-digit', minute: '2-digit', timeZone: this.tz }).format(d);
    }
    fmtDayShort(dk) {
      var p = dk.split('-');
      return new Intl.DateTimeFormat(this.loc, { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(noonUTC(+p[0], +p[1], +p[2]));
    }
    fmtWhen(d) {
      var date = new Intl.DateTimeFormat(this.loc, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: this.tz }).format(d);
      return date + ', ' + this.fmtTime(d) + ' (' + this.tzLabel(this.tz) + ')';
    }

    setMsg(text) {
      this.el.msg.textContent = text || '';
      this.el.msg.hidden = !text;
    }

    renderTimes() {
      var s = this.s;
      var days = this.cache[this.monthKey()];
      this.el.times.innerHTML = '';
      this.el.cont.disabled = !this.selectedSlot;

      if (this.loading) {
        this.el.timesTitle.textContent = s.loading || '';
        this.setMsg('');
        this.classList.add('is-loading');
        return;
      }
      this.classList.remove('is-loading');

      if (this.loadError) {
        this.el.timesTitle.textContent = '';
        this.setMsg(s.loadError);
        return;
      }
      if (days && !Object.keys(days).length) {
        this.el.timesTitle.textContent = '';
        this.setMsg(s.none);
        return;
      }
      if (this._takenMsg) { this.setMsg(s.taken); this._takenMsg = false; } else { this.setMsg(''); }

      if (!this.selectedDay || !days || !days[this.selectedDay]) {
        this.el.timesTitle.textContent = s.pick || '';
        return;
      }
      this.el.timesTitle.textContent = (s.available || '{date}').replace('{date}', this.fmtDayShort(this.selectedDay));

      days[this.selectedDay].forEach((d) => {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'seed-vb__time';
        b.textContent = this.fmtTime(d);
        b.dataset.start = d.toISOString();
        var on = this.selectedSlot && this.selectedSlot.getTime() === d.getTime();
        if (on) b.classList.add('is-selected');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.addEventListener('click', () => {
          this.selectedSlot = d;
          this.renderTimes();
          this.el.cont.focus({ preventScroll: true });
        });
        this.el.times.appendChild(b);
      });
    }

    /* ---------- steps */
    show(n) {
      [this.el.step1, this.el.step2, this.el.step3].forEach(function (st, i) { st.hidden = i !== n - 1; });
      var target = n === 1 ? this.el.step1 : n === 2 ? this.el.step2 : this.el.step3;
      if (n !== 1) {
        var r = this.getBoundingClientRect();
        if (r.top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (n === 2) { var f = this.el.step2.querySelector('input'); if (f) f.focus({ preventScroll: true }); }
      if (n === 3) target.focus({ preventScroll: true });
    }

    goStep2() {
      if (!this.selectedSlot) return;
      this.el.summary.textContent = this.fmtWhen(this.selectedSlot);
      this.el.formMsg.hidden = true;
      this.show(2);
    }

    book() {
      var form = this.el.step2;
      if (!form.reportValidity()) return;
      var fd = new FormData(form);
      var first = String(fd.get('first_name') || '').trim();
      var last = String(fd.get('last_name') || '').trim();
      var email = String(fd.get('email') || '').trim();
      var phone = String(fd.get('phone') || '').trim();
      var notes = String(fd.get('notes') || '').trim();

      var noteLines = ['Phone: ' + phone, 'Website language: ' + this.lang.toUpperCase(), 'Booked from: ' + location.pathname];
      if (notes) noteLines.push('', notes);

      var body = {
        start: this.selectedSlot.toISOString(),
        username: this.user,
        eventTypeSlug: this.event,
        attendee: {
          name: (first + ' ' + last).trim(),
          email: email,
          timeZone: this.tz,
          language: ['en', 'ru', 'uk', 'ar'].indexOf(this.lang) > -1 ? this.lang : 'en'
        },
        bookingFieldsResponses: { notes: noteLines.join('\n') },
        metadata: { source: 'seed-website', phone: phone.slice(0, 60), lang: this.lang, page: location.pathname.slice(0, 200) }
      };

      var btn = this.el.submit;
      btn.disabled = true;
      btn.textContent = this.s.booking || '...';
      this.el.formMsg.hidden = true;

      fetch(this.api + '/bookings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'cal-api-version': '2026-02-25' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
        })
        .then((res) => {
          if (res.ok && res.json && res.json.status === 'success') {
            var data = res.json.data || {};
            var pending = data.status === 'pending';
            var when = this.fmtWhen(this.selectedSlot);
            this.querySelector('[data-done-title]').textContent = pending ? this.s.pendingTitle : this.s.okTitle;
            this.querySelector('[data-done-when]').textContent = when;
            this.querySelector('[data-done-text]').textContent = (pending ? this.s.pendingText : this.s.okText).replace('{email}', email);
            form.reset();
            this.show(3);
            try {
              window.dispatchEvent(new CustomEvent('seed:virtual-booked', { detail: { start: body.start, pending: pending } }));
            } catch (e) {}
            return;
          }
          var msg = JSON.stringify(res.json || {}).toLowerCase();
          console.warn('[seed-virtual-booking] booking', res.status, res.json);
          if (res.status === 409 || /not available|no available|already|taken|booked|busy|conflict/.test(msg)) {
            // Slot gone: back to step 1 with fresh times
            delete this.cache[this.monthKey()];
            this.selectedSlot = null;
            this._takenMsg = true;
            this.show(1);
            this.load(false);
            return;
          }
          this.el.formMsg.textContent = this.s.bookError;
          this.el.formMsg.hidden = false;
        })
        .catch((err) => {
          console.warn('[seed-virtual-booking] booking', err);
          this.el.formMsg.textContent = this.s.bookError;
          this.el.formMsg.hidden = false;
        })
        .finally(() => {
          btn.disabled = false;
          btn.textContent = this.s.confirm;
        });
    }
  }

  customElements.define('seed-virtual-booking', SeedVirtualBooking);
})();
